import { useLocation } from "react-router-dom";

export default function useUrlQueryParams() {
  const location = useLocation();
  return Object.fromEntries(new URLSearchParams(location.search).entries());
}
